const CONTEXT_USER_ID_KEY = "clientContextUserId";
const VISITED_URLS_KEY = "clientContextVisitedUrls";
const API_CALLS_KEY = "clientContextApiCalls";
const MAX_VISITED_URLS = 5;
const MAX_API_CALLS = 15;

function readArray(key) {
    try {
        const value = JSON.parse(localStorage.getItem(key) || "[]");
        return Array.isArray(value) ? value : [];
    } catch {
        return [];
    }
}

function writeArray(key, value, maxItems) {
    localStorage.setItem(key, JSON.stringify(value.slice(0, maxItems)));
}

function normalizeUrl(value) {
    const url = new URL(value, window.location.origin);
    return url.pathname + url.search + url.hash;
}

function resolveClientContext() {
    let sessionAccountId = null;
    try {
        sessionAccountId = JSON.parse(localStorage.getItem("sessionData") || "{}").id;
    } catch {
        sessionAccountId = null;
    }

    if (sessionAccountId) {
        sessionAccountId = String(sessionAccountId);
    }

    if (!sessionAccountId) {
        sessionAccountId = localStorage.getItem(CONTEXT_USER_ID_KEY);
        if (!sessionAccountId) {
            sessionAccountId = crypto.randomUUID ? crypto.randomUUID() : `browser-${Date.now()}-${Math.random().toString(36).slice(2)}`;
            localStorage.setItem(CONTEXT_USER_ID_KEY, sessionAccountId);
        }
    }

    return {
        userId: sessionAccountId,
        visitedUrls: readArray(VISITED_URLS_KEY),
        apiCalls: readArray(API_CALLS_KEY),
        telemetry: {
            browser: navigator.userAgent,
            language: navigator.language,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || null
        }
    };
}

export function trackVisitedUrl(url = window.location.href) {
    const normalizedUrl = normalizeUrl(url);
    const visitedUrls = readArray(VISITED_URLS_KEY).filter(item => item !== normalizedUrl);
    writeArray(VISITED_URLS_KEY, [normalizedUrl, ...visitedUrls], MAX_VISITED_URLS);
}

export function trackApiCall(method, endpoint) {
    const apiCalls = readArray(API_CALLS_KEY);
    writeArray(API_CALLS_KEY, [
        {
            method: String(method || "GET").toUpperCase(),
            endpoint: normalizeUrl(endpoint)
        },
        ...apiCalls
    ], MAX_API_CALLS);
}

export function sendClientContext() {
    const endpoint = `${window.env.apiEndpoint}/api/v1/public/client-context`;
    const payload = JSON.stringify(resolveClientContext());

    if (navigator.sendBeacon) {
        const blob = new Blob([payload], { type: "application/json" });
        if (navigator.sendBeacon(endpoint, blob)) {
            return;
        }
    }

    fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: payload,
        credentials: "include",
        keepalive: true
    }).catch(() => { });
}
